// third-party
import { FormattedMessage } from 'react-intl';
import PaidIcon from '@mui/icons-material/Paid';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SellIcon from '@mui/icons-material/Sell';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import SettingsIcon from '@mui/icons-material/Settings';

// assets
import {
    IconDashboard,
    IconDeviceAnalytics,
    IconUserCheck,
    IconReceipt2,
    IconClipboardList,
    IconPresentationAnalytics,
    IconCurrencyDollarCanadian
} from '@tabler/icons';

// constant
const icons = {
    IconDashboard,
    IconDeviceAnalytics,
    IconUserCheck,
    IconReceipt2,
    IconClipboardList,
    IconPresentationAnalytics,
    IconCurrencyDollarCanadian,
    PaidIcon,
    DashboardIcon,
    PersonIcon,
    ReceiptLongIcon,
    RotateLeftIcon,
    SellIcon,
    SettingsIcon
};

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [
        {
            id: 'super_admin',
            type: 'group',
            children: [
                {
                    id: 'dashboard',
                    title: <FormattedMessage id="Dashboard" />,
                    type: 'item',
                    url: '/',
                    icon: icons.DashboardIcon,
                    breadcrumbs: false
                },
                {
                    id: 'users',
                    title: <FormattedMessage id="User Management" />,
                    type: 'item',
                    url: '/users',
                    icon: icons.PersonIcon,
                    breadcrumbs: false
                },
                {
                    id: 'transactions',
                    title: <FormattedMessage id="Transactions" />,
                    type: 'item',
                    url: '/transactions',
                    icon: icons.ReceiptLongIcon,
                    breadcrumbs: false
                },
                {
                    id: 'fee',
                    title: <FormattedMessage id="Fee Management" />,
                    type: 'item',
                    icon: icons.PaidIcon,
                    url: '/fee',
                    breadcrumbs: false
                },
                {
                    id: 'resetpassword',
                    title: <FormattedMessage id="Reset Password" />,
                    type: 'item',
                    icon: icons.RotateLeftIcon,
                    url: '/resetpassword',
                    breadcrumbs: false
                },
                {
                    id: 'promoCode',
                    title: <FormattedMessage id="Promo Code" />,
                    type: 'item',
                    icon: icons.SellIcon,
                    url: '/promocode',
                    breadcrumbs: false
                },
                {
                    id: 'settings',
                    title: <FormattedMessage id="Settings" />,
                    type: 'collapse',
                    icon: icons.SettingsIcon,
                     disableHover: true,
                    children: [
                        {
                            id: 'version-management',
                            title: <FormattedMessage id="Version" />,
                            type: 'item',
                            url: '/settings/version',
                            breadcrumbs: false
                        }
                    ]
                }
            ]
        }
    ]
};

export default menuItems;